// src/api/systemLogsApi.js
import api from './api'; // your configured axios instance

/**
 * Fetch System Logs from the backend
 * @param {object} filters 
 *   {
 *     action: string,
 *     username: string,
 *     startDate: 'YYYY-MM-DD',
 *     endDate: 'YYYY-MM-DD'
 *   }
 * @returns {Promise} Axios Promise
 */
export const getSystemLogs = (filters = {}) => {
  const { action, username, startDate, endDate } = filters;
  const queryParams = new URLSearchParams();

  if (action) {
    queryParams.append('action', action);
  }
  if (username) {
    queryParams.append('username', username);
  }
  if (startDate) {
    queryParams.append('startDate', startDate);
  }
  if (endDate) {
    queryParams.append('endDate', endDate);
  }

  // GET /logs/SystemLogs?action=...&username=...&startDate=...
  return api.get(`/logs/SystemLogs?${queryParams.toString()}`);
};
export const deleteLogsForPeriod = async (startDate, endDate) => {
  const queryParams = new URLSearchParams();
  if (startDate) queryParams.append('startDate', startDate);
  if (endDate) queryParams.append('endDate', endDate);

  const response = await api.delete(`/logs/SystemLogs?${queryParams.toString()}`);
  return response.data;
};